import { render, staticRenderFns } from "./TestWork.vue?vue&type=template&id=30066baf&scoped=true"
import script from "./TestWork.vue?vue&type=script&lang=js"
export * from "./TestWork.vue?vue&type=script&lang=js"
import style0 from "./TestWork.vue?vue&type=style&index=0&id=30066baf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30066baf",
  null
  
)

export default component.exports